import React, { useState } from "react"
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api"
import "./google-map.css"
import Tabs from "../tabs"
import { markerIcons } from "./marker-data"
import MapCenterIcon from "../../../assets/icons/map-center.svg"
import InitialCenter from "../../../assets/icons/initial-center.svg"
import IconButton from "../icon-button"

const mapOptions = {
  styles: [
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "landscape",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ visibility: "visible" }],
    },
  ],
  gestureHandling: "greedy",
}
const libraries = ["places", "geometry"]

const CustomGoogleMap = ({
  poi,
  locations,
  selectedTab,
  handleTabChange,
  geoLocation,
  isPlaceSelected,
  selectedMarker,
  handleMarkerClick,
  handleMapDragged,
  handleResetMapCenter,
}) => {
  const [mapref, setMapRef] = useState(null)

  const handleOnLoad = (map) => {
    setMapRef(map)
  }

  const handleDragEnd = () => {
    const center = mapref.getCenter()
    const lat = center.lat()
    const lng = center.lng()
    handleMapDragged({ lat, lng })
  }

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={libraries}>
      <div className="w-fit flex flex-col items-center">
        <div className="relative w-full md:w-fit">
          <Tabs
            className="absolute z-50 w-full"
            selectedTab={selectedTab}
            handleTabChange={handleTabChange}
          />
          <GoogleMap
            mapContainerClassName="w-full md:w-96 lg:w-147 pt-[75%] md:h-96 lg:h-136"
            center={geoLocation}
            zoom={15}
            className="relative"
            options={mapOptions}
            onLoad={handleOnLoad}
            onDragEnd={handleDragEnd}>
            {isPlaceSelected && (
              <Marker
                position={poi}
                key={"map-center"}
                icon={{ url: MapCenterIcon }}
                clickable={false}
                zIndex={1000}
              />
            )}

            {locations?.map((location) => {
              return (
                <Marker
                  position={{ lat: location.latitude, lng: location.longitude }}
                  key={location.id}
                  icon={{
                    url:
                      selectedMarker === location.id
                        ? markerIcons[selectedTab].selected
                        : markerIcons[selectedTab].icon,
                  }}
                  onClick={(_e) => handleMarkerClick(location.id)}
                />
              )
            })}
          </GoogleMap>
          <IconButton
            className={
              "absolute z-50 bg-white left-2.5 bottom-5 md:bottom-8 !w-8 !h-8 md:!w-10 md:!h-10 lg:!w-[50px] lg:!h-[50px]"
            }
            icon={InitialCenter}
            imgClassName=" fill-black w-5 h-5 md:w-6 md:h-6"
            title={"poi"}
            onClick={handleResetMapCenter}
          />
        </div>

        <p className="w-full md:w-96 lg:w-147 text-center text-primary italic">
          Browsing Tip: Click on the target icon to show workspaces in your live
          location.
        </p>
      </div>
    </LoadScript>
  )
}

export default React.memo(CustomGoogleMap)
